//导入创建好的axios实例
import { request } from './request';

//导出login方法，供其它地方使用
export function gettrain(data) {
	return request({
		url: '/api/train/gettrain',
		method: 'get',
		params: data,
	})
}
//培训列表查询
export function certificate(data) {
	return request({
		url: '/api/train/certificate',
		method: 'get',
		params: data,
	})
}
//培训详情
export function getinfo(data) {
	return request({
		url: '/api/train/getinfo',
		method: 'post',
		data,
	})
}
